import { useTranslation } from 'react-i18next';

import { AnimationShell, Button, Field, Form, Input } from '@/components';
import { useState } from 'react';
import { ShowPassword } from '../show-password';

export type CredentialsFormFields = {
  email: string;
  password: string;
};

export type CredentialsFormProps = {
  readonly onSubmit: (data: CredentialsFormFields) => void;
};

export function CredentialsForm({ onSubmit }: CredentialsFormProps) {
  const { t } = useTranslation(['signin']);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form<CredentialsFormFields> onSubmit={onSubmit}>
      {({ register, formState }) => (
        <div className="flex flex-col space-y-7">
          <Field
            id="email"
            label={t(`Email address`)}
            error={formState.errors['email']}
            delay={0}
            classes={{ field: 'space-y-1' }}
          >
            <Input
              type="email"
              color={formState.errors['email'] ? 'error' : 'primary'}
              placeholder={t(`john.doe@example.com`)}
              autoComplete="email"
              registration={register('email', { required: t(`This field is required`) })}
            />
          </Field>

          <Field
            id="password"
            label={t(`Password`)}
            error={formState.errors['password']}
            delay={0.15}
            classes={{ field: 'space-y-1' }}
          >
            <Input
              type={showPassword ? 'text' : 'password'}
              autoComplete="new-password"
              color={formState.errors['password'] ? 'error' : 'primary'}
              registration={register('password', { required: t(`This field is required`) })}
              rightElement={<ShowPassword showPassword={showPassword} setShowPassword={setShowPassword} />}
            />
          </Field>

          <AnimationShell type="opacity" delay={0.25}>
            <Button type="submit" size="lg" className="w-full">
              {t(`Sign in`)}
            </Button>
          </AnimationShell>
        </div>
      )}
    </Form>
  );
}
